// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__pSDlA","tab":"ProcedureTabs_tab__2wPnE"};